import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * This plugin ensures that certain nodes (such as tables, and various extension ones)
 * have a unique `localId` attribute value for `fragment` marks.
 * It also ensures the preservation of these IDs when nodes are being cut-and-pasted
 * around the document.
 *
 * The implementation has been _heavily_ borrowed from
 * - packages/editor/editor-core/src/plugins/table/pm-plugins/table-local-id.ts
 */
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { uuid } from '@atlaskit/adf-schema';
import { getChangedNodes } from '../../../utils/document';
var pluginKey = new PluginKey('fragmentMarkConsistencyPlugin');
var getNodesSupportingFragmentMark = function getNodesSupportingFragmentMark(schema) {
  var _schema$nodes = schema.nodes,
    table = _schema$nodes.table,
    extension = _schema$nodes.extension,
    bodiedExtension = _schema$nodes.bodiedExtension,
    inlineExtension = _schema$nodes.inlineExtension;
  return [table, extension, bodiedExtension, inlineExtension];
};

/**
 * Ensures presence of `fragment` mark on certain node types and the uniqueness of their `localId` attributes
 */
export var createPlugin = function createPlugin(dispatch) {
  return new SafePlugin({
    key: pluginKey,
    appendTransaction: function appendTransaction(transactions, _oldState, newState) {
      var modified = false;
      var tr = newState.tr;
      var fragment = newState.schema.marks.fragment;
      var supportedNodeTypes = getNodesSupportingFragmentMark(newState.schema);
      var addedSupportedNodes = new Set();
      var addedSupportedNodesPos = new Map();
      var localIds = new Set();
      transactions.forEach(function (transaction) {
        if (!transaction.docChanged) {
          return;
        }

        // Don't interfere with cut as it clashes with fixTables & we don't need
        // to handle any extra cut cases in this plugin
        var uiEvent = transaction.getMeta('uiEvent');
        if (uiEvent === 'cut') {
          return;
        }
        var changedNodes = getChangedNodes(transaction);
        var _iterator = _createForOfIteratorHelper(changedNodes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var node = _step.value.node;
            if (!supportedNodeTypes.includes(node.type)) {
              continue;
            }
            addedSupportedNodes.add(node);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      if (!addedSupportedNodes.size) {
        return;
      }

      // Get existing fragment marks localIds on the page
      newState.doc.descendants(function (node, pos) {
        if (addedSupportedNodes.has(node)) {
          addedSupportedNodesPos.set(node, pos);
          return true;
        }
        if (!supportedNodeTypes.includes(node.type)) {
          return true;
        }
        var existingFragmentMark = node.marks.find(function (mark) {
          return mark.type === fragment;
        });
        if (!existingFragmentMark) {
          // continue traversing
          return true;
        }
        localIds.add(existingFragmentMark.attrs.localId);
        return true;
      });

      // If an added node has localId that collides with existing node, generate new localId
      var _iterator2 = _createForOfIteratorHelper(addedSupportedNodes),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var node = _step2.value;
          var pos = addedSupportedNodesPos.get(node);
          if (pos === undefined) {
            continue;
          }
          var existingFragmentMark = node.marks.find(function (mark) {
            return mark.type === fragment;
          });
          if (!existingFragmentMark) {
            continue;
          }
          if (localIds.has(existingFragmentMark.attrs.localId)) {
            tr.setNodeMarkup(pos, undefined, node.attrs, node.marks.map(function (mark) {
              if (mark.type !== fragment) {
                return mark;
              }
              var fragmentMark = fragment.create(_objectSpread(_objectSpread({}, mark.attrs), {}, {
                localId: uuid.generate(),
                name: null
              }));
              return fragmentMark;
            }));
            modified = true;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (modified) {
        return tr;
      }
      return;
    }
  });
};